
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22.5","cy":"22.5","r":"21","fill":"#337DF6","stroke":"#fff","stroke-width":"3"}}),_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M30.623 21.178l-1.23-.267a6.69 6.69 0 00-.395-.955l.68-1.058a.478.478 0 00-.063-.597l-1.916-1.916a.478.478 0 00-.597-.064l-1.058.681a6.69 6.69 0 00-.955-.396l-.267-1.23a.478.478 0 00-.467-.376h-2.71a.478.478 0 00-.467.377l-.267 1.23a6.69 6.69 0 00-.955.395l-1.058-.68a.478.478 0 00-.597.063l-1.916 1.916a.478.478 0 00-.064.597l.681 1.058a6.69 6.69 0 00-.396.955l-1.23.267a.478.478 0 00-.376.467v2.71c0 .224.157.419.377.467l1.23.267c.106.328.239.647.395.955l-.68 1.058a.478.478 0 00.063.597l1.916 1.916a.478.478 0 00.597.064l1.058-.681c.308.156.628.289.955.396l.267 1.23c.048.22.242.376.467.376h2.71c.224 0 .419-.157.467-.377l.267-1.23a6.69 6.69 0 00.955-.395l1.058.68c.19.122.438.096.597-.063l1.916-1.916a.478.478 0 00.064-.597l-.681-1.058a6.69 6.69 0 00.396-.955l1.23-.267a.478.478 0 00.376-.467v-2.71a.478.478 0 00-.377-.467zM25.869 23A2.872 2.872 0 0123 25.869 2.872 2.872 0 0120.131 23 2.872 2.872 0 0123 20.131 2.872 2.872 0 0125.869 23z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M15 15h16v16H15z"}})])])])
          )
        }
      }
    